import { Box } from '@spark-web/box';
import { Heading } from '@spark-web/heading';
import { ApplicationSubmissionStatus } from '../../pages/ApplicationStatus/types';
import { useGetPageTitle } from './hooks';

type PageTitleProps = {
  readonly status?: ApplicationSubmissionStatus;
};

function PageTitle({ status }: PageTitleProps) {
  const pageTitle = useGetPageTitle(status);
  return (
    // Spark's Heading level isn't responsive, so render the title at a smaller level on mobile (level 2)
    // and the full level 1 from tablet up, keeping h1 semantics via `as`.
    <>
      <Box display={{ mobile: 'none', tablet: 'block' }}>
        <Heading level="1" align="center">
          {pageTitle}
        </Heading>
      </Box>
      <Box display={{ mobile: 'block', tablet: 'none' }}>
        <Heading as="h1" level="2" align="center">
          {pageTitle}
        </Heading>
      </Box>
    </>
  );
}

export default PageTitle;
